import { environment } from './../../../../../environments/environment.test';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { ActivatedRoute, Router } from '@angular/router';
import { Dominio, DominioFilter, Dominios, DominiosFilter } from '@core/models/dominio';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DialogService } from '@core/services/dialog.service';
import { DominiosService } from '@core/services/dominios.service';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { MessageService } from '@core/services/message.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { DominiosSharedDataService } from '@modules/dominios/dominios-shared-data.service';
import { ColumnOrder } from '@core/table/order';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { RoleEnum } from '@core/models/role';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { CargoReferenciaService } from '@core/services/cargoreferencia.service';
import { PerfilEnum } from '@core/models/perfil';

@Component({
  selector: 'app-dominio-list',
  templateUrl: './dominio-list.component.html',
  styleUrls: ['./dominio-list.component.css']
})
export class DominioListComponent implements OnInit, AfterViewInit {

  dataSet: Dominio[] = [];
  titulo!: string;
  nomeDominio!: string;
  nomeTratadoDominio!: string;
  descricaoDominio!: string;


  dominioFilterForm!: FormGroup;
  filtro = new DominioFilter();
  roleEnum = RoleEnum;
  perfilEnum = PerfilEnum;
  columOrder: ColumnOrder | undefined;
  tipoEntidadeList: any[] = [];

  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  colunasVisiveis: string[] = [];
  size: NzButtonSize = 'large';
  isEditing = false;
  nzFilterOption = (): boolean => true;
  cargoReferenciaList: any[] = [];
  especializacaoSubtipoList: any[] = [];

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    private dominiosService: DominiosService,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NzModalService,
    private dominiosSharedDataService: DominiosSharedDataService,
    private appSignalDataService: AppSignalDataService,
    private tipoEntidadeService: TipoEntidadeService,
    private cargoReferenciaService: CargoReferenciaService
  ) { }

  ngOnInit() {

    this.dominioFilterForm = this.formBuilder.group({
      nome: [],
      telasPermitidas: [],
      cargoSubordinadoId: [],
      tiposEntidades: [],
      tipoEntidade: [],
      cargoReferencia: [],
      idTipoEntidade: [],
      idEspecificacao: [],
      incluirInativos: [false]
    });

    this.tipoEntidadeService.listarPorTipoEnum().subscribe((data) => {
      this.tipoEntidadeList = data;
    }
    );

    this.cargoReferenciaService.listar().subscribe((data) => {
      this.cargoReferenciaList = data;
    }
    );

    this.dominiosSharedDataService.updateList$.subscribe(() => {
      this.consultar();
    });

    this.route.data.subscribe((data) => {
      if (data['dominio']) {
        this.descricaoDominio = data['dominio'].descricao;
        console.log('Descrição do domínio:', this.descricaoDominio);
        this.configurarColunas();
      }
    });

    // if (this.descricaoDominio === "Tipos do subTipo de Entidade") {
    this.tipoEntidadeService.listarEspecificacoes().subscribe((res: any) => {
      this.especializacaoSubtipoList = res;
    });
    // }
  }



  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.route.data.subscribe((data) => {
      if (data['dominio']) {
        this.titulo = data['dominio'].descricao;
        this.nomeDominio = data['dominio'].nome;
        console.log('Nome do domínio:', this.nomeDominio);
      }
    });

    this.paginator.change.subscribe((val) => {
      this.consultar();
    });

    this.consultar();
  }


  pesquisar(): void {
    this.filtro = { ...this.dominioFilterForm.value };
    this.paginator.reset();
    this.consultar();
  }




  consultar(): void {
    if (this.nomeDominio !== 'SUB_TIPO_ENTIDADE') {
      if (this.columOrder) {
        this.dominiosService.consultarSort(
          this.nomeDominio,
          this.filtro,
          this.paginator.pagination,
          this.columOrder
        ).subscribe((data) => {
          this.dataSet = data.content;
          this.paginator.totalItens = data.totalElements;
        });
      } else {
        this.dominiosService.consultarDominio(
          this.nomeDominio,
          this.filtro,
          this.paginator.pagination
        ).subscribe((data) => {
          this.dataSet = data.content;
          this.dataSet.sort((a, b) => a.nome.localeCompare(b.nome));
          this.paginator.totalItens = data.totalElements;
        });
      }
    } else {
      this.tipoEntidadeService.consultarSort(
        this.filtro,
        this.paginator.pagination,
           this.columOrder
      ).subscribe((data) => {
        this.dataSet = data.content;
        this.paginator.totalItens = data.totalElements;
      });
    }
  }

  novo() {
    this.router.navigate([`/dominios/${this.nomeDominio}/cadastrar`], { state: { titulo: this.titulo } });
  }

  editar(obj: Dominio) {
    this.router.navigate([`/dominios/${this.nomeDominio}/editar/${obj.id}`], { state: { titulo: this.titulo } });
  }

  inativar(obj: Dominio): void {
    if (this.nomeDominio === 'CARGO_REFERENCIA' && Array.isArray(obj.cargosAssociados) && obj.cargosAssociados.length > 0 && obj.dataInativo == null) {
      this.messageService.warning(
        'Não é possível inativar este cargo, pois ele está associado à hierarquia de cargos de uma ou mais entidades.'
      );
      return;
    }

    if (this.nomeDominio === 'ESPECIALIZACAO_SUB_TIPO_ENTIDADE') {
      if (obj.existeCargosAssociados) {
        this.dialogService.info(
          'Atenção',
          'Não é possível inativar este domínio, pois ele possui cargos associados.',
          () => { }
        );
        return;
      }


      const possuiVinculos = !!obj.nomeSubTipoAssociado && obj.nomeSubTipoAssociado.trim().length > 0;
      const acao = obj.dataInativo ? 'ativar' : 'inativar';
      const message = possuiVinculos
        ? `Deseja realmente ${acao} o domínio <b>${obj.nome}</b>? Ele possui subtipos associados cadastrados. Os vínculos serão ${acao === 'ativar' ? 'reativados' : 'inativados'} automaticamente.`
        : `Deseja realmente ${acao} o domínio <b>${obj.nome}</b>?`;

      this.dialogService.confirm(message, () => {
        const service = obj.dataInativo
          ? this.dominiosService.reativar(this.nomeDominio, obj.id)
          : this.dominiosService.deletar(this.nomeDominio, obj.id);

        service.subscribe(() => {
          this.messageService.success(`Domínio ${obj.dataInativo ? 'reativado' : 'inativado'} com sucesso!`);
          this.consultar();
        });
      });
      return;
    }

    if (this.nomeDominio === 'SUB_TIPO_ENTIDADE') {
      const possuiVinculos = Array.isArray(obj.especificacoesStr) && obj.especificacoesStr.length > 0;
      const acao = obj.dataInativo ? 'ativar' : 'inativar';
      const message = possuiVinculos
        ? `Deseja realmente ${acao} o domínio <b>${obj.nomeSubTipoEntidade}</b>? Ele possui tipos associados cadastrados. Os vínculos serão ${acao === 'ativar' ? 'reativados' : 'inativados'} automaticamente.`
        : `Deseja realmente ${acao} o domínio <b>${obj.nomeSubTipoEntidade}</b>?`;

      this.dialogService.confirm(message, () => {
        const service = obj.dataInativo
          ? this.tipoEntidadeService.ativarSubTipoEntidade(obj.id)
          : this.tipoEntidadeService.inativarSubTipoEntidade(obj.id);

        service.subscribe(() => {
          this.messageService.success(`Domínio ${obj.dataInativo ? 'reativado' : 'inativado'} com sucesso!`);
          this.consultar();
        });
      });
      return;
    }

    const acao = obj.dataInativo ? 'ativar' : 'inativar';
    this.dialogService.confirm(`Deseja realmente ${acao} o domínio?`, () => {
      const service = obj.dataInativo
        ? this.dominiosService.reativar(this.nomeDominio, obj.id)
        : this.dominiosService.deletar(this.nomeDominio, obj.id);

      service.subscribe(() => {
        this.messageService.success(`Domínio ${obj.dataInativo ? 'reativado' : 'inativado'} com sucesso!`);
        this.consultar();
      });
    });
  }



  resetarItensMudarEntidade() {
    this.subTipoControl.setValue(null);
    this.dataSet = [];
  }

  get subTipoControl(): any {
    return this.dominioFilterForm.get('subTipo');
  }




  resetForm() {
    this.dominioFilterForm.reset();
    this.pesquisar();
  }

  voltar() {
    const isUpperCase = this.nomeDominio === this.nomeDominio.toUpperCase();
    if (this.nomeDominio && !isUpperCase) {
      this.router.navigate([`/dominios/${this.nomeDominio}`]);
    } else {
      window.history.back();
    }
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = { sortField: itemSelected.key, sortOrder: itemSelected.value };
      this.consultar();
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    const dominioAtual = this.route.snapshot.data['dominio']?.nome;

    if (this.nomeDominio !== 'SUB_TIPO_ENTIDADE') {
      this.dominiosService.consultarSort(dominioAtual, this.filtro, this.paginator.pagination, params)
        .subscribe((data) => {
          this.dataSet = data.content;
          this.paginator.totalItens = data.totalElements;
        });
    } else {
      this.tipoEntidadeService.consultarSort(this.filtro, this.paginator.pagination, params)
        .subscribe((data) => {
          this.dataSet = data.content;
          this.paginator.totalItens = data.totalElements;
        });
    }
  }



  transformarListaEmString(lista: any[] = []): string {
    return lista.map(item => item.nomeTipoEntidade || item.nome).join('|');
  }

  configurarColunas(): void {
    console.log(this.route?.snapshot?.data['dominio']?.nome);
    if (this.descricaoDominio === "Cargo de Referência") {
      this.colunasVisiveis = ['nome', 'tipoCargo', 'cargosAssociados']; // Colunas visíveis para este título
    } else if (this.descricaoDominio === "Cargo Por Tipo de Entidade") {
      this.colunasVisiveis = ['nomeCargoReferencia', 'cargoSubordinadoId', 'tipoEntidade', 'tipoCargo', 'nivelHierarquico'];
    } else if (this.descricaoDominio === "Tipo de Contato") {
      this.colunasVisiveis = ['nome', 'telasPermitidas'];
    } else if (this.descricaoDominio === "Grupo") {
      this.colunasVisiveis = ['nome', 'tipoGrupo', 'sigiloso'];
    } else if (this.descricaoDominio === "Sub Tipo de Entidade") {
      this.colunasVisiveis = ['nomeSubTipoEntidade', 'nomeTipoEntidade', 'especificacoesStr'];
    } else if (this.descricaoDominio === "Tipos do subTipo de Entidade") {
      this.colunasVisiveis = ['nome', 'nomeSubTipoAssociado', 'existeCargosAssociados'];
    } else if (this.descricaoDominio === "Tipo de Entidade") {
      this.colunasVisiveis = ['nome', 'nomeSubTipoAssociado'];
    } else {
      this.colunasVisiveis = ['nome']; // Colunas visíveis para este título
    }
  }

  // Gera as tags "SubTipo - Especificação" ou "SubTipo - Default"
  getSubTipoTags(item: any): string[] {
    if (!item?.subTipos?.length) return [];

    return item.subTipos.flatMap((st: any) => {
      const nomeST = st?.nomeSubTipoEntidade ?? '—';
      const especs = st?.especificacoes ?? [];

      if (especs.length) {
        return especs.map((e: any) => `${nomeST} - ${e?.nome ?? 'Default'}`);
      }

      // se não tiver especificações
      return [`${nomeST} - Default`];
    });
  }


  audio() {
    if (true) {
      const audio = new Audio('assets/audio/cat-meow-sound-383823.mp3');
      audio.play();
    }
  }
}
